/* CYL Covenant Pendant guard (July 2026)
 *
 * The Covenant Pendant (product 14991212511599, $25) is a chainless
 * add-on: it slides onto a TMS necklace chain and must not be bought
 * on its own. This guard watches the cart and, when the pendant is
 * present without any chain-providing product, shows the warning row
 * in the drawer footer ([data-cyl-pendant-guard], rendered by
 * sections/cart-drawer.liquid) and blocks the checkout click in the
 * capture phase (beats the drawer's own delegated handler).
 *
 * CHAIN_IDS = every product that puts a chain in the cart: the 5
 * necklaces (PEF, Locket, Heart, Glory of Zion, Classic Gift Set) and
 * every bundle/set whose components include one of them. Bundles
 * normally expand into component line items, so the component ids
 * alone would match; the parent ids are belt-and-braces in case a
 * cart ever holds the unexpanded parent line.
 *
 * Server-side backstop: the covenant-pendant-guard checkout
 * validation function (Shopify Functions) enforces the same rule at
 * checkout, so this file is UX, not security.
 */
(function () {
  'use strict';

  var PENDANT_ID = 14991212511599;
  var CHAIN_IDS = [
    // necklaces with chains
    14717716300143, // The Pendant of Eternal Faith
    14727252476271, // The Locket of Divine Promise
    14882821800303, // Heart of Unfailing Love
    14945723613551, // The Glory of Zion
    14718228791663, // The Classic Gift Set (contains PEF)
    // bundle/set parents whose components include a necklace
    14992466903407, 14992473784687, 14992474767727,
    15007266177391, 15007266242927, 14764792545647,
    14766801158511, 14864180937071, 14864192274799,
    14864515006831, 14764801393007, 14953523151215,
    14953523183983, 14953523216751, 14997327806831,
    14997331738991, 14991011316079, 14991014330735,
    14991022457199, 14991024980335, 14991034351983,
    14991037923695, 14998882517359, 15002011468143
  ];

  var blocked = false;

  function guardEl() {
    return document.querySelector('[data-cyl-pendant-guard]');
  }

  function evaluate(cart) {
    if (!cart || !cart.items) return;
    var hasPendant = false;
    var hasChain = false;
    cart.items.forEach(function (it) {
      if (it.product_id === PENDANT_ID) hasPendant = true;
      if (CHAIN_IDS.indexOf(it.product_id) !== -1) hasChain = true;
    });
    blocked = hasPendant && !hasChain;

    var el = guardEl();
    if (el) el.hidden = !blocked;

    document.querySelectorAll('[data-cd-action="checkout"]').forEach(function (btn) {
      btn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      btn.style.opacity = blocked ? '0.45' : '';
      btn.style.cursor = blocked ? 'not-allowed' : '';
    });
  }

  // Capture-phase guard: fires before the drawer's own delegated
  // click handler (which does window.location = '/checkout') and
  // before any cart-page form submission.
  document.addEventListener('click', function (e) {
    if (!blocked) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var hit = t.closest(
      '[data-cd-action="checkout"], [name="checkout"], a[href^="/checkout"], a[href*="/checkout?"]'
    );
    if (!hit) return;
    e.preventDefault();
    e.stopPropagation();
    var el = guardEl();
    if (el) {
      el.hidden = false;
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      el.classList.remove('cyl-guard-pulse');
      void el.offsetWidth; // restart the pulse animation
      el.classList.add('cyl-guard-pulse');
    }
  }, true);

  document.addEventListener('cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart) evaluate(cart);
  });

  function boot() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) evaluate(c); })
      .catch(function () { /* silent */ });
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
